import { createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorPayload } from "@application/common/helpers/api-helper";
import OrderLineApi from "@infrastructure/orderline-api";
import { addSuccessNotification } from "../common/notificationSlice";
export const getArticalByIdAsync = createAsyncThunk('artical/GetById', async (articalId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await OrderLineApi.getArticleById(articalId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllArticalsAsync = createAsyncThunk('workorder/GetAllArticals', async (_, { rejectWithValue }) => {
    try {
        const response = await OrderLineApi.getAllArticals();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkOrdersListWithClientAsync = createAsyncThunk('OrderLine/GetWorkOrdersListWithClientAsync', async (workOrderNumber, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await OrderLineApi.getWorkOrdersListWithClientAsync(workOrderNumber);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createOrderLineAsync = createAsyncThunk('OrderLine/Create', async (workorder, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderLineApi.CreateOrderLine(workorder);
        dispatch(addSuccessNotification("Record succesvol aangemaakt"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateOrderLineAsync = createAsyncThunk('OrderLine/Update', async (material, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderLineApi.UpdateOrderLine(material.id, material);
        dispatch(addSuccessNotification("Record succesvol bijgewerkt"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllOrderLineByOrderIdAsync = createAsyncThunk('OrderLine/GetAllOrderLinesByOrderId', async (orderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await OrderLineApi.getAllorderLinesByOrderID(orderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getOrderLineByIDAsync = createAsyncThunk('OrderLine/GetOrderLineByID', async (Id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await OrderLineApi.getOrderLineByID(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteOrderLineAsync = createAsyncThunk(`OrderLine/Delete`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderLineApi.deleteOrderLine(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const recievedAllOrderLinesAsync = createAsyncThunk('OrderLine/RecievedAllOrderLines', async (orderId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderLineApi.recievedAllOrderLines(orderId);
        dispatch(addSuccessNotification('Records succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const removeWorkOrderIdLinkedWithOrderLinesAsync = createAsyncThunk('OrderLine/RemoveWorkOrderIdLinkedWithOrderLinesAsync', async (Id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderLineApi.removeWorkOrderIdLinkedWithOrderLines(Id);
        dispatch(addSuccessNotification('Bestel regels succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateBulkOrderLineAsync = createAsyncThunk('OrderLine/UpdateBulkOrderLine', async (orderLines, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await OrderLineApi.updateBulkOrderLine(orderLines);
        dispatch(addSuccessNotification('Record succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
